export interface InsurabilityType {
  readonly ct1: string;
  readonly ct2: string;
}

export class Insurability implements InsurabilityType {
  ct1: string;
  ct2: string;

  constructor(data?: InsurabilityType) {
    this.ct1 = "";
    this.ct2 = "";
    data && Object.assign(this, data);
  }
}
